import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, CalendarDays, Layers, Search, ArchiveRestore } from 'lucide-react';

const TomoFeatures = () => {
  const items = [
    { icon: CheckCircle2, title: 'Smart Task Creation', desc: 'Set title, description, category, priority, and due date with ease' },
    { icon: Layers, title: 'Dynamic Category Filtering', desc: 'Auto-extracted categories enable fast, focused filtering' },
    { icon: Search, title: 'Real-time Search', desc: 'Instantly search through all task content to find what you need' },
    { icon: CalendarDays, title: 'Clear Scheduling', desc: 'Visualize and manage due dates efficiently' },
    { icon: ArchiveRestore, title: 'History Archive', desc: 'Completed tasks are auto-archived with restore or permanent delete' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Everything You Need to Stay Organized
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, idx) => (
            <motion.div
              key={idx}
              className="bg-white rounded-2xl p-6 shadow-sm border border-amber-100"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.05 }}
            >
              <it.icon className="w-7 h-7 text-orange-600 mb-3" />
              <div className="font-semibold text-gray-900 mb-1">{it.title}</div>
              <div className="text-sm text-gray-600 leading-relaxed">{it.desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TomoFeatures; 